import { Component, OnInit, Output, EventEmitter, Input, HostListener } from '@angular/core';
import { ProfileService } from '../../profile.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogOverviewConfirmationComponent } from '../../dialog-overview-confirmation/dialog-overview-confirmation.component';

@Component({
  selector: 'lib-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit {
  isRead;
  dataToPass: any;
  @Output() dataEvent = new EventEmitter();
  @Input() passAppList;
  @Input() privacyData = '';
  @Input() termsData = '';
  @Input() appId = '';
  @Input() logOutUrl;
  @Input() userprinciplename;
  policyData: Array<any> = [];
  consentValueCheck: any = {};
  indexValue = 0;
  constructor(
    private userService: ProfileService,
    public dialog: MatDialog) { }
  @HostListener('copy', ['$event']) blockCopy(e: KeyboardEvent) {
    e.preventDefault();
  }

  @HostListener('cut', ['$event']) blockCut(e: KeyboardEvent) {
    e.preventDefault();
  }
  ngOnInit() {
    if (!!localStorage.getItem('policyData')) {
      this.policyData = JSON.parse(localStorage.getItem('policyData'));
      if (this.policyData.length) {
        this.consentValueCheck = this.policyData.find(res => res.appId == this.appId)? this.policyData.find(res => res.appId == this.appId).policyAgreement:'';
        if (Object.keys(this.consentValueCheck).length) {
          if (this.consentValueCheck.privacyFlag && this.consentValueCheck.termsFlag) {

          }
        }
      }
    }
  }
  ngOnChanges() {
    if (this.passAppList) {
      this.isRead = this.passAppList.isConsentAgreement;
    }
  }
  onRightClick(event) {
    return false;
  }
  onChangePolicy(e) {
    this.isRead = !this.isRead;
    if (!e.checked) {
      const dialogRef = this.dialog.open(DialogOverviewConfirmationComponent, {
        width: '500px',
        disableClose: true
      });
      this.dataToPass = {
        privacyConfirm: true,
        userId: this.userprinciplename
      };
      dialogRef.componentInstance.confirmData = this.dataToPass;
      dialogRef.afterClosed().subscribe(result => {
        if (result.event === 'consentModify') {
          this.dataEvent.emit({ event: 'consentUpdates' });
          setTimeout(() => {
            this.userService.logout();
            window.location.href = this.logOutUrl;
          }, 2000);
        } else if (result.event === 'cancelConsern') {
          this.isRead = true
        }
      });
    }
  }
}
